import { render } from "./MsColorPicker.vue?vue&type=template&id=07695fa7&scoped=true"
import script from "./MsColorPicker.vue?vue&type=script&lang=js"
export * from "./MsColorPicker.vue?vue&type=script&lang=js"

import "./MsColorPicker.vue?vue&type=style&index=0&id=07695fa7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07695fa7"]])

export default __exports__